import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/audit").then((module) => ({
    default: module.AdminAudit,
  })),
);

export const Route = createFileRoute("/admin/audit")({
  component: Page,
});
